import { GET_MY } from '../../containers/App/constants';
import { FETCH_HEXON, FETCH_HEXON_CONTROL_PANEL_URL } from './constants';

export function fetchHexonAds(page) {
    return {
      type: GET_MY,
      work: FETCH_HEXON,
      id: FETCH_HEXON,
      path: `hexon/ads`,
    };
  }

  export function fetchControlPanelUrl() {
    return {
      type: GET_MY,
      work: FETCH_HEXON_CONTROL_PANEL_URL,
      gate: FETCH_HEXON_CONTROL_PANEL_URL,
      id: FETCH_HEXON_CONTROL_PANEL_URL,
      path: `hexon/control-panel-url`,
    };
  }
    